import * as ContextMenuPrimitive from "@radix-ui/react-context-menu";

import { cn } from "../../utils";

import { ContextMenuItem } from "./ContextMenuItem";
import type { ContextMenuItems } from "./types";

interface ContextMenuContentProps<TData> {
  contextMenuItems?: ContextMenuItems<TData>[];
  data: TData;
  preventAutoFocusOnClose?: boolean;
}

export const ContextMenuContent = <TData,>({
  contextMenuItems,
  data,
  preventAutoFocusOnClose = false,
}: ContextMenuContentProps<TData>) => (
  <ContextMenuPrimitive.Content
    onCloseAutoFocus={event => {
      if (preventAutoFocusOnClose) {
        event.preventDefault();
      }
    }}
    className={cn(
      "z-50 flex min-w-[8rem] flex-col gap-1 overflow-hidden rounded-md border border-gray-300 bg-white px-3 py-2 shadow-lg",
      "data-[state=open]:animate-in data-[state=closed]:animate-out",
      "data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      "data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95",
      "data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2",
      "data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
    )}
  >
    {contextMenuItems?.map(contextMenuItem => (
      <ContextMenuItem key={contextMenuItem.id} contextMenuItem={contextMenuItem} data={data} />
    ))}
  </ContextMenuPrimitive.Content>
);
